<div class="flex flex-col gap-2">
  <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="stageFile($event)" #curriculumUpdate />

  <span class="f-s-18">Submit a new curriculum for approval</span>

  <div>
    <button type="button" mat-raised-button class="m-8" color="primary" aria-label="Update Curriculum"
      (click)="curriculumUpdate.click()">
      Select File
      <mat-icon>attach_file</mat-icon>
    </button>
  </div>

  <div *ngIf="file.name !== 'empty'" class="flex flex-row gap-4">
    <span>Selected Curriculum:</span>
    <span>{{file.name}}</span>
  </div>

  <form [formGroup]="commentsForm">
    <mat-form-field class="flex-1">
      <mat-label>
        Please identify and describe the material changes
      </mat-label>
      <textarea matInput rows="4" placeholder="Changes" type="text"
        formControlName="comments"></textarea>
      <mat-error *ngIf="commentsForm.get('comments').invalid">
        A description of the changes is required
      </mat-error>
    </mat-form-field>
  </form>

  <div class="flex flex-row gap-2">
    <button mat-raised-button type="submit" color="primary" (click)="saveFile()" [disabled]="!commentsForm.valid || file.name === 'empty'">Submit</button>
    <button mat-raised-button type="button" color="warn" (click)="cancel()">Cancel</button>
  </div>
</div>
